const PREFIX = 'superPicker:amberwood:v1';
export const amberwoodStorageKey = (userId: string) => `${PREFIX}:${encodeURIComponent(userId.trim().toUpperCase())}`;

export const AMBERWOOD_BANNER_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

/** The Project Research banner's × hides it for this agent for seven days. */
export function snoozeAmberwoodBanner(storage: Storage, userId: string, now = Date.now()): void {
  storage.setItem(`${amberwoodStorageKey(userId)}:bannerHiddenAt`, String(now));
}

export function isAmberwoodBannerSnoozed(storage: Storage, userId: string, now = Date.now()): boolean {
  try {
    const hiddenAt = Number(storage.getItem(`${amberwoodStorageKey(userId)}:bannerHiddenAt`));
    return Number.isFinite(hiddenAt) && hiddenAt > 0 && now - hiddenAt < AMBERWOOD_BANNER_SNOOZE_MS;
  } catch {
    return false;
  }
}
